import { DateTime } from "luxon";

const convertUtcDatesToBerlin = (obj: any): any => {
  // if oject is an array of objects
  if (Array.isArray(obj)) {
    return obj.map((item) => convertUtcDatesToBerlin(item));
  }

  // Go through each key in the object
  for (const key in obj) {
    // if key has name "createdAt" or "updatedAt"
    if (key === "createdAt" || key === "updatedAt") {
      // Convert the date string to a DateTime object
      const dateTime = DateTime.fromISO(obj[key], { zone: "utc" });
      // Convert to Berlin time zone
      const berlinDateTime = dateTime
        .setZone("Europe/Berlin")
        .toFormat("yyyy-MM-dd HH:mm:ss");
      // Format the date to a readable string
      obj[key] = berlinDateTime;
    }
  }

  return obj;
};

export default convertUtcDatesToBerlin;
